import type { Container } from '@subaio/webapp'

const context = require.context('containers', true, /^\.\/(([^/]+\/)*)page\.(js|ts|tsx)$/)

export const containers = context
	.keys()
	.map((resource) => {
		const [, name] = /^\.\/(([^/]+\/)*)page\.(js|ts|tsx)$/.exec(resource)!
		const container = context(resource).container as Container

		return { name: name.slice(0, -1), container }
	})
	.reduce(
		(obj, { name, container }) => {
			obj[name] = container
			return obj
		},
		{} as Record<string, Container>,
	)

/** Helper method to get containers cast to appropriate local type */
export const getContainers = <TContainer extends Container<any, any, any, any, any, any, any>>() =>
	containers as Record<string, TContainer>
